import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';
import { addItemsToCart, updateUserCartData } from 'aster-foundation/core/epharmacy/Cart/redux/actions';
import { ButtonBase } from '@common/Component/Forms';
import { checkAndUpdateOldCartId, errorHandlingEpharmacy, getProductPath, removeDecimalPoints } from '@common/Utility/common-utils';
import { setTotalQtyData } from 'Epharmacy/MyCart/redux/reducer';
import logger from '@common/Utility/logger';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { setProductItemQtyMultiple } from '../redux/reducer';
import FBTUpsellingProduct from './FBTUpsellingProduct';
import { dataLayerSendEvent, getProductItemObjectEventFbtUpselling } from 'Epharmacy/EpharmacyAnalytics';
import { FBTStyled } from './FBTStyled';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { CART_TYPES, FLAGSMITH_KEYS, LOCALSTORAGE_KEYS, MY_CART_ROUTE } from '@common/Utility/constants';
import { getPage } from '@common/Constants/analytics';
import { flagsmith } from '@common/Lib/Flagsmith';

const FBTSection = ({ fbtSkuId, productInCart, notInCart, emptyProductId, setShowUpselling, setFbt_disabled, pageId, pageType, screenName, referrerpage, sectionName, fbtProducts }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo);
  const fbtLoading = useSelector((state) => state?.epharmacy?.getFBTProductsBySearch.isFetching);
  const cartData = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const getCartV2Data = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const reducerItems = useSelector((state) => state?.app?.pdpReducer?.items);
  const isMyCartPage = router?.pathname?.indexOf(MY_CART_ROUTE) > -1;

  const [newDataSet, setNewDataSet] = useState([]);
  const [itemList, setItemList] = useState({});
  const [fbt_addedtocart, setFbt_addedtocart] = useState(false);
  const [fbtButtonLoading, setFbtButtonLoading] = React.useState(false);
  const [fbtButton, setFbtButton] = React.useState(false);

  const totalItems = Object.keys(itemList).filter((e) => itemList[e].checkedState);
  const totalPrice = totalItems.reduce((initial, next) => initial + itemList[next].price, 0);

  useEffect(() => {
    if (fbt_addedtocart) {
      const filteredItems = getCartV2Data?.delivery_groups?.flatMap(group => group?.items?.filter(item => fbtSkuId?.includes(item?.sku)));
      const filteredIndices = newDataSet
        ?.map((fbtProductsDatas, index) => ({ fbtProductsDatas, index }))
        ?.filter(({ fbtProductsDatas }) => filteredItems?.[filteredItems?.length - 1]?.sku?.includes(fbtProductsDatas?.sku))
        ?.map(({ index }) => index);
      if (filteredItems?.length > 0) {
        dataLayerSendEvent('add_to_cart', {
          ecommerce: {
            items: filteredItems?.slice(-1)?.map((element) => {
              return { ...getProductItemObjectEventFbtUpselling(element), index: parseInt(filteredIndices) + 1 };
            }),
          },
          bundle_name: null,
          currency: "AED",
          promotion_name: null,
          promotion_value_tag: null,
          bundle_deal_availability: filteredItems?.isbundle ? true : false,
          section_name: "fbt upselling",
          screen_name: screenName,
          page_type: "product details page",
          page_id: pageId,
          value: filteredItems[filteredItems.length - 1]?.price,
          total_discount: 0,
          referrer_page: referrerpage,
          myaster_category: 'epharmacy',
        });
        sendEventToSmartLook('add_to_cart');
      }
    }

  }, [getCartV2Data?.delivery_groups, fbtSkuId]);

  useEffect(() => {
    if (fbtButton) {
      dataLayerSendEvent('add_to_cart', {
        ecommerce: {
          items: newDataSet?.map((element, index) => {
            return { ...getProductItemObjectEventFbtUpselling(element), index };
          }),
        },
        bundle_name: null,
        promotion_name: null,
        promotion_value_tag: null,
        bundle_deal_availability: false,
        section_name: "fbt upselling",
        screen_name: screenName,
        page_type: "product details page",
        page_id: pageId,
        total_discount: 0,
        value: parseInt(totalPrice),
        currency: "AED",
        referrer_page: referrerpage,
        myaster_category: 'epharmacy',
      });
      sendEventToSmartLook('add_to_cart');
    }

  }, [fbtButton]);

  const handleCheckedItems = (id, isChecked) => {
    itemList[id].checkedState = isChecked;
    const updatedItem = { ...itemList };
    setItemList(updatedItem);
  };

  React.useEffect(() => {
    const sortedFbtArray = [];
    fbtSkuId?.map((fbtId) => {
      const fbt = fbtProducts?.find((item) => item.sku === fbtId);
      if (fbt && fbt.inStock) {
        sortedFbtArray.push(fbt);
      }
      return fbtId;
    });
    setNewDataSet(sortedFbtArray);
    const fbtObject = {};
    sortedFbtArray.map((item) => {
      fbtObject[item.sku] = { checkedState: true, price: item.special_price ? item.special_price : item.price };
      return item;
    });
    setItemList(fbtObject);
  }, [fbtProducts]);

  const fbtAddToCart = () => {
    setFbtButtonLoading(true);
    setFbtButton(true);
    const selectedItems = Object.entries(itemList)
      .filter((item) => item?.[0] !== productInCart && item?.[1].checkedState)
      .map(([sku, item]) => ({
        sku,
        ...item
      }))
    const updatedItems = selectedItems.map(item => {
      return {
        item_id: item.sku,
        qty: 1,
        price: parseFloat(item.price),
      };
    });

    const { page, sub_type } = getPage(router?.asPath);
    const items = updatedItems.map((item) => ({
      quantity: item?.qty,
      sku: item?.sku || item?.item_id,
    }));

    const params = {
      cartType: CART_TYPES.AE,
      page,
      ...(sub_type && { sub_type }),
      items,
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    if (userZoneData) {
      params.zones = userZoneData;
    }
    if (isMyCartPage) {
      params.showCart = true;
    }
    if (items.length > 0 && items) {
      dispatch(addItemsToCart({
        params,
        onSuccess: (res) => {
          checkAndUpdateOldCartId(res?.cart_id);
          if (res?.message && res?.failed_skus) {
            toast.error(res?.message);
            setFbtButtonLoading(false);
            setShowUpselling(false);
            const failedSkus = res?.failed_skus || [];
            const filteredUpdatedItems = updatedItems.filter(
              newItem => !failedSkus.includes(newItem.item_id)
            );

            const combinedItems = [...reducerItems];
            filteredUpdatedItems.forEach(newItem => {
              const existingItemIndex = combinedItems.findIndex(existingItem => existingItem.item_id === newItem.item_id);
              if (existingItemIndex !== -1) {
                combinedItems[existingItemIndex].qty += newItem.qty;
                combinedItems[existingItemIndex].price = newItem.price;
              } else {
                combinedItems.push(newItem);
              }
            });

            const totalQuantity = combinedItems.reduce((total, item) => total + item.qty, 0);
            dispatch(setProductItemQtyMultiple(combinedItems));
            dispatch(setTotalQtyData(totalQuantity));
          } else {
            setShowUpselling(false);
            setFbtButtonLoading(false);
            emptyProductId();
            localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
            if (isMyCartPage) {
              dispatch(updateUserCartData ({body: res}));
              // TODO: Keeping this for reference. Will remove after testing
              // EventEmitter.dispatch('fetchCartDetails', { cartIdParam: cartData?.cart_id });
            }
            const combinedItems = [...reducerItems];
            updatedItems.forEach(newItem => {
              const existingItemIndex = combinedItems.findIndex(existingItem => existingItem.item_id === newItem.item_id);
              if (existingItemIndex !== -1) {
                combinedItems[existingItemIndex].qty += newItem.qty;
                combinedItems[existingItemIndex].price = newItem.price;
              } else {
                combinedItems.push(newItem);
              }
            });
            const totalQuantity = combinedItems.reduce((total, item) => total + item.qty, 0);
            dispatch(setProductItemQtyMultiple(combinedItems));
            dispatch(setTotalQtyData(totalQuantity));
          }
        },
        onFailure: (error) => {
          errorHandlingEpharmacy(error, true, screenName, pageType);
          logger.error('FBT Add to Cart', error);
          setFbtButtonLoading(false);
          setShowUpselling(false);
        },
      }));
    }
  };

  const totalCheckedItems = () => {
    const totalItems = Object.keys(itemList).filter((e) => e !== productInCart && itemList[e].checkedState);
    let buttonText = '';
    if (totalItems.length > 1) {
      buttonText = `Add All Items To Cart`;
    } else if (totalItems.length === 1) {
      buttonText = `Add Item To Cart`;
    } else {
      buttonText = `Select items to buy together`;
    }
    return buttonText;
  };

  const isButtonDisabled = () => {
    const totalItems = Object.keys(itemList).filter((e) => e !== productInCart && itemList[e].checkedState);
    return totalItems.length === 0;
  };
  const fbt2Product = fbtProducts?.data?.data?.length === 2;

  return (
    newDataSet && newDataSet?.length > 0 && !fbtLoading && (
      <FBTStyled fbt2Product={fbt2Product} upSellingFbt={true}>
        <div className="fbt-container">
          <div className="fbt-product-container">
            {newDataSet.map((product, index) => (
              <FBTUpsellingProduct
                key={product?.productId}
                id={product?.sku}
                arrayLength={fbtSkuId.length}
                image={product?.small_image || ''}
                price={`AED ${removeDecimalPoints(String(product?.special_price || product?.price))}`}
                previousPrice={product?.special_price ? `AED ${removeDecimalPoints(String(product?.price))}` : null}
                title={product?.name}
                isFirstElement={index === 0}
                // onClick={fbtAddToCart} // TODO: not being used so kept it commented
                handleCheckedItems={handleCheckedItems}
                link={getProductPath(product)}
                cartData={cartData?.delivery_groups || []}
                parentSku={newDataSet[0].sku}
                productInCart={productInCart}
                notInCart={notInCart}
                newDataSet={product}
                setFbt_disabled={setFbt_disabled}
                setShowUpselling={setShowUpselling}
                setFbt_addedtocart={setFbt_addedtocart}
                pageId={pageId}
                screenName={screenName}
                referrerpage={referrerpage}
                pageType={pageType}
                sectionName={sectionName}
                product={product}
                index={index}
              />
            ))}
          </div>
          <ButtonBase
            outerCustomClass="buy-button fbt-cart-btn"
            data-test="FBTBuyButton"
            enableFullWidth
            size="sm"
            variant={`outline-success ${(() => {
              if (fbtButtonLoading) {
                return 'fbtLoadingText';
              }
              return '';
            })()}`}
            text={(() => {
              if (fbtButtonLoading) {
                return 'Loading...';
              }
              return totalCheckedItems();
            })()}
            onClick={fbtAddToCart}
            disabled={isButtonDisabled() || fbtButtonLoading}
          />
        </div>
      </FBTStyled>
    )
  );
};

FBTSection.propTypes = {
  fbtSkuId: PropTypes.array,
  productInCart: PropTypes.string,
  notInCart: PropTypes.array,
  emptyProductId: PropTypes.func,
};

FBTSection.defaultProps = {
  fbtSkuId: [],
  productInCart: '',
  notInCart: [],
  emptyProductId: () => { },
};

export default FBTSection;
